'use client';

import '@ui5/webcomponents/dist/CheckBox.js';
import { ValueState } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * Allows the user to set a binary value, such as true/false or yes/no for an item.
 *
 * The `CheckBox` component consists of a box and a label that describes its purpose. If it's checked, an indicator is displayed inside the box. To check/uncheck the `CheckBox`, the user has to click or tap the square box or its label.
 *
 * The `CheckBox` component only has 2 states - checked and unchecked. Clicking or tapping toggles the `CheckBox` between checked and unchecked state.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/CheckBox" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const CheckBox = withWebComponent('ui5-checkbox', ['accessibleName', 'accessibleNameRef', 'name', 'text', 'valueState', 'wrappingType'], ['checked', 'disabled', 'indeterminate', 'readonly', 'required'], [], ['change']);
CheckBox.displayName = 'CheckBox';
CheckBox.defaultProps = {
  valueState: ValueState.None
};
export { CheckBox };